"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canonicalizeSignalNameForComparison = canonicalizeSignalNameForComparison;
const normalize_signal_name_1 = require("./normalize-signal-name");
const OVERLINE_WRAPPER = /\\overline\{([^}]*)\}/g;
const OVERLINE_COMBINING = /[̅‾̄]/g;
const CANONICAL_OVERLINE_MARKER = '̅';
function parseOverline(name) {
    const hadWrapper = OVERLINE_WRAPPER.test(name);
    OVERLINE_WRAPPER.lastIndex = 0;
    const withoutWrapper = name.replace(OVERLINE_WRAPPER, '$1');
    const hadCombining = OVERLINE_COMBINING.test(withoutWrapper);
    OVERLINE_COMBINING.lastIndex = 0;
    return { base: withoutWrapper.replace(OVERLINE_COMBINING, ''), hadOverline: hadWrapper || hadCombining };
}
function canonicalizeSignalNameForComparison(name) {
    const { base, hadOverline } = parseOverline(name);
    const normalized = (0, normalize_signal_name_1.normalizeSignalName)(base).toLowerCase();
    return hadOverline ? `${normalized}${CANONICAL_OVERLINE_MARKER}` : normalized;
}
//# sourceMappingURL=signal-name-canonicalization.js.map